import React from 'react';

/**
 * CoverageBar — thin horizontal progress bar showing shift coverage.
 * covered / total → emerald (100%), amber (50-99%), red (<50%)
 */
const CoverageBar = ({ covered = 0, total = 0, showText = true }) => {
  const pct     = total > 0 ? Math.round((covered / total) * 100) : 0;
  const color   = pct === 100 ? 'bg-emerald-500' : pct >= 50 ? 'bg-amber-400' : 'bg-red-400';
  const textCls = pct === 100 ? 'text-emerald-600' : pct >= 50 ? 'text-amber-600' : 'text-red-500';

  return (
    <div className="flex items-center gap-2 min-w-[100px]">
      <div className="flex-1 h-1.5 rounded-full bg-muted overflow-hidden">
        <div
          className={`h-full rounded-full transition-all ${color}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      {showText && (
        <span className={`text-xs font-medium tabular-nums ${textCls}`}>
          {covered}/{total}
        </span>
      )}
    </div>
  );
};

export default CoverageBar;
